import React from "react";
import { SALES_STAGES, CONTACT_OUTCOMES } from "../../constants";

const getStageLabel = (key) => {
    return SALES_STAGES.find(s => s.key === key)?.label || key;
};

const getOutcomeLabel = (key) => {
    return CONTACT_OUTCOMES.find(o => o.key === key)?.label || key;
};

const formatDateTime = (isoString) => {
    if (!isoString) return "";
    const date = new Date(isoString);
    return date.toLocaleString("pt-BR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

const PlatformLeadTimeline = ({ interactions = [] }) => {
    if (interactions.length === 0) {
        return (
            <div className="text-center py-4 text-muted font-size-13">
                Nenhuma interação ou contato registrado para este lead.
            </div>
        );
    }

    return (
        <div className="crm-timeline-container p-2">
            <ul className="list-unstyled mb-0">
                {interactions.map((item, idx) => {
                    let iconClass = "mdi mdi-note-text-outline text-muted";
                    let bgClass = "bg-light";
                    let title = "Anotação";
                    let details = item.messageText || item.outcomeNotes || "";

                    if (item.type === "stage_change") {
                        iconClass = "mdi mdi-swap-horizontal text-primary";
                        bgClass = "bg-soft-primary";
                        title = "Mudança de Estágio";
                        details = `Mapeamento alterado: ${getStageLabel(item.stageFrom)} ➔ ${getStageLabel(item.stageTo)}. ${item.outcomeNotes ? `Obs: ${item.outcomeNotes}` : ""}`;
                    } else if (item.type === "manual_contact") {
                        iconClass = item.channel === "whatsapp" 
                            ? "mdi mdi-whatsapp text-success" 
                            : item.channel === "email" 
                                ? "mdi mdi-email-outline text-info" 
                                : "mdi mdi-phone-outgoing text-warning";
                        bgClass = item.channel === "whatsapp" 
                            ? "bg-soft-success" 
                            : item.channel === "email" 
                                ? "bg-soft-info" 
                                : "bg-soft-warning";
                        title = `Contato via ${item.channel === "whatsapp" ? "WhatsApp" : item.channel === "email" ? "E-mail" : "Telefone"}`;
                        details = `Resultado: ${getOutcomeLabel(item.outcome)}. ${item.outcomeNotes ? `Obs: ${item.outcomeNotes}` : ""}`;
                    } else if (item.type === "auto_message") {
                        iconClass = "mdi mdi-robot-outline text-purple";
                        bgClass = "bg-soft-purple";
                        title = `Mensagem Automática (${item.messageTemplate || "Trigger"})`;
                        details = item.messageText || "Envio automático pelo sistema.";
                    }

                    return (
                        <li key={item.id || idx} className="crm-timeline-item">
                            <div className={`rounded-circle crm-timeline-icon-wrap ${bgClass}`}>
                                <i className={iconClass}></i>
                            </div>
                            
                            <div className="crm-timeline-content">
                                <div className="crm-timeline-header">
                                    <span className="crm-timeline-title">{title}</span>
                                    <span className="crm-timeline-date">{formatDateTime(item.createdAt)}</span>
                                </div>
                                <p className="crm-timeline-details">
                                    {details}
                                </p>
                                <div className="crm-timeline-author">
                                    <i className="mdi mdi-account-outline me-1"></i> Por {item.consultantName || "Sistema"}
                                </div>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default PlatformLeadTimeline;
